import api from "../api/api"
import componentLocales from '../locales/components/locales'
import pageLocales from '../locales/pages/locales'
import userReducer from "../reducer/currentUser/currentUser"
import gridStateReducer from '../reducer/gridState/gridState'
import menuReducer from '../reducer/menu/menu'
import router from '../routers/routes'
import grantReducer from "../reducer/grantApplicationForm/grantReducer";

export const loadModules = (modules) => {
	return ({
			loadPermissions: () => {
				// Bundle all permissions from modules and combine them with general permissions
				return modules.reduce((prv, curr) => {
					const { permissions, modules } = curr
					if (!permissions) return prv
					return ({
						...prv,
						...(modules ? loadModules(modules).loadPermissions() : {}),
						...permissions,
					})
				}, {})
			},
			loadRoutes: () => {
				// Bundle all routes from modules and combine them from
				const applicationRoutes = router ? router : {}
				const routes = modules.reduce((prv, curr) => {
					const { routes, modules } = curr
					return ({
						...prv,
						...(modules ? loadModules(modules).loadRoutes() : {}),
						...(routes ? routes : {}),
					})
				}, applicationRoutes)
				return Object.keys(routes).map(key => routes[key])
			},
			getTranslations: () => {
				// Bundle all translations from modules
				return modules.reduce((prv, curr) => {
					const { name, locales, modules } = curr
					if (!locales) return prv
					return ({
						...prv,
						...(modules ? loadModules(modules).getTranslations() : {}),
						...(locales ? { [name]: locales } : {}),
					})
				}, {
					// General translations
					component_translations: componentLocales,
					page_translations: pageLocales,
				})
			},
			getRequestHandlers: () => {
				// Bundle API redux calls from modules
				return modules.reduce((prv, curr) => {
					const { name, api, modules } = curr
					if (!api) return prv
					return ({
						...prv,
						...(modules ? loadModules(modules).getRequestHandlers() : {}),
						[name]: api,
					})
				}, {
					// General API for redux calls
					app_request: api,
				})
			},
			loadReducers: () => {
				// Bundle reducers from modules
				return modules.reduce((prv, curr) => {
					const { name, reducer, modules } = curr
					if (!reducer) return prv
					return {
						...prv,
						...(modules ? loadModules(modules).loadReducers() : {}),
						[name]: {
							initialState: reducer.initialState,
							handlers: reducer.handlers
						},
					}
				}, {
					// General Reducers
					currentUser: userReducer,
					gridState: gridStateReducer,
					menu: menuReducer,
					grant: grantReducer
				})
			}
		}
	)
}
